export default function (a) {
  console.log(a);
  return "";
}
